export const REFRESH_TOKEN = 'refresh_token';
export const ID_TOKEN = 'id_token';
export const ACCESS_TOKEN = 'access_token';
export const SESSION_TOKEN = 'session_token';
export const USER = 'user';
export const CAPTCHA_SITE_KEY = "6LcjSqoqAAAAAKs2TM_-dctRFNbBHGAo7uZnjyDd";